module.exports = __webpack_public_path__ + "img/projectAdvantage-lazy.58f84694.png";